import { createRouter, createWebHashHistory } from 'vue-router'
import { showToast } from 'vant'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home.vue')
  },
  {
    path: '/community',
    name: 'Community',
    component: () => import('../views/community.vue')
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('../views/mine.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/admin/admin.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/template/add',
    name: 'TemplateAdd',
    component: () => import('../views/admin/TemplateAdd.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/template/:id',
    name: 'TemplateDetail',
    component: () => import('../views/template.vue')
  },
  {
    path: '/customize/:id',
    name: 'Customize',
    component: () => import('../views/customize.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/result/:id',
    name: 'Result',
    component: () => import('../views/result.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查该路由是否需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查用户是否已登录
    if (!localStorage.getItem('token')) {
      // 未登录，跳转到登录页面
      next({
        path: '/login',
        // 保存原本要去的路径，登录成功后可以跳回去
        query: { redirect: to.fullPath }
      })
    } else {
      // 检查是否需要管理员权限
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        // 从localStorage获取用户信息
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        // 检查用户是否是管理员
        if (userInfo && parseInt(userInfo.user_role) === 1) {
          // 是管理员，允许访问
          next();
        } else {
          // 不是管理员，返回首页
          showToast && showToast('权限不足，仅限管理员访问');
          next('/');
        }
    } else {
      // 已登录，正常跳转
      next()
      }
    }
  } else {
    // 不需要登录权限的路由，直接跳转
    next()
  }
})

export default router 